import React from 'react';
import { RadioGroup, FormControlLabel, Radio, FormControl, Box } from '@mui/material';
var DecisionRadioGroup = function DecisionRadioGroup(_ref) {
  var input = _ref.input,
    meta = _ref.meta,
    name = _ref.name,
    onChange = _ref.onChange,
    disabled = _ref.disabled,
    labels = _ref.labels,
    translate = _ref.translate;
  var handleChange = function handleChange(event) {
    var value = event.target.value;
    if (onChange) {
      onChange(value);
    }
    if (input && input.onChange) {
      input.onChange(value);
    }
  };
  var currentValue = input && input.value !== undefined ? input.value : '';
  return /*#__PURE__*/React.createElement(FormControl, {
    component: "fieldset",
    disabled: disabled
  }, /*#__PURE__*/React.createElement(RadioGroup, {
    name: name,
    value: currentValue,
    onChange: handleChange,
    row: true
  }, labels.map(function (label, index) {
    return /*#__PURE__*/React.createElement(FormControlLabel, {
      key: index,
      value: label,
      control: /*#__PURE__*/React.createElement(Radio, null),
      label: translate ? translate(label) : label
    });
  })));
};
export default DecisionRadioGroup;